import {
  Activity,
  AtSign,
  Landmark,
  HeartPulse,
  Rows3,
  GalleryVerticalEnd,
  Clapperboard,
  MessageSquare,
  Sparkle,
  Bookmark,
  BookmarkCheck,
  Quote,
  Hash,
  Layers,
  Flame,
  Languages,
  CircleHelp,
  Zap,
  SquareCheck,
  Pill,
  Grid3x3,
  Bomb,
  Brain,
  RotateCcw,
  Eraser,
  Mail,
  BookOpen,
  Heart,
  VolumeX,
  ExternalLink,
  Music,
  MousePointerClick,
  Ban,
  UserMinus,
  Camera,
  Archive,
  ArrowLeft,
  BadgeCheck,
  BatteryLow,
  Bell,
  Pause,
  Play,
  Inbox,
  BellOff,
  CalendarDays,
  ChartColumn,
  Check,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Megaphone,
  ChevronDown,
  CircleDashed,
  Compass,
  QrCode,
  Coins,
  Calculator,
  Ruler,
  Minus,
  Clock,
  WifiOff,
  House,
  Navigation,
  Store,
  Copy,
  Share2,
  FolderDown,
  Download,
  EllipsisVertical,
  FileText,
  Flag,
  Forward,
  GraduationCap,
  Info,
  KeyRound,
  LayoutGrid,
  Boxes,
  PinOff,
  Dock,
  PanelBottomClose,
  AppWindow,
  LayoutTemplate,
  Link,
  List,
  Lock,
  LockOpen,
  CornerDownLeft,
  FingerprintPattern,
  Eye,
  EyeOff,
  MapPin,
  LogOut,
  Maximize2,
  MessageCircle,
  Mic,
  MicOff,
  Minimize2,
  Monitor,
  Moon,
  Palette,
  Paperclip,
  Pencil,
  Phone,
  PhoneIncoming,
  PhoneMissed,
  PhoneOff,
  PhoneOutgoing,
  ArrowDownLeft,
  ArrowUpRight,
  PictureInPicture2,
  Pin,
  Plus,
  Repeat,
  Reply,
  Search,
  SendHorizontal,
  Settings,
  ShieldCheck,
  SlidersHorizontal,
  Smile,
  Sparkles,
  Square,
  Star,
  Sticker,
  Images,
  Headphones,
  CalendarPlus,
  Sun,
  SwitchCamera,
  Ticket,
  Timer,
  Trash,
  TriangleAlert,
  User,
  UserPlus,
  Users,
  Video,
  VideoOff,
  Volume2,
  WandSparkles,
  X,
  BriefcaseBusiness,
  CircleCheck,
  CircleMinus,
  Dumbbell,
  Siren,
  CloudSun,
  Radio,
  Gamepad2,
  Globe,
  ClipboardList,
  ListChecks,
  Newspaper,
  Code,
  Brush,
  Waves,
  Target,
  Trophy,
  Cloud,
  CloudRain,
  CloudSnow,
  CloudLightning,
  CloudFog,
  CloudDrizzle,
  CloudMoon,
  Droplets,
  Wind,
  Sunrise,
  Sunset,
  Thermometer,
  LocateFixed,
  Map as MapIcon,
  Crosshair,
  Package,
  Truck,
  ScanBarcode,
  type LucideIcon,
} from 'lucide-react';

// One consistent, professional stroke set (Lucide, ISC licence). The app keeps its own short names, so a
// screen never depends on the library's naming; every icon has a size, so none can grow to fill its box.
const ICONS = {
  messages: MessageCircle,
  calls: Phone,
  spaces: Boxes,
  apps: LayoutGrid,
  calendar: CalendarDays,
  learn: GraduationCap,
  discover: Compass,
  compass: Compass,
  qr: QrCode,
  coins: Coins,
  calculator: Calculator,
  ruler: Ruler,
  minus: Minus,
  clock: Clock,
  wifiOff: WifiOff,
  home: House,
  navigation: Navigation,
  store: Store,
  ai: Sparkles,
  settings: Settings,
  lock: Lock,
  unlock: LockOpen,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  enter: CornerDownLeft,
  fingerprint: FingerprintPattern,
  eye: Eye,
  eyeOff: EyeOff,
  location: MapPin,
  shield: ShieldCheck,
  user: User,
  userMinus: UserMinus,
  ban: Ban,
  users: Users,
  palette: Palette,
  bell: Bell,
  key: KeyRound,
  monitor: Monitor,
  flag: Flag,
  ticket: Ticket,
  activity: Activity,
  status: CircleDashed,
  sliders: SlidersHorizontal,
  list: List,
  alert: TriangleAlert,
  logout: LogOut,
  back: ArrowLeft,
  chevron: ChevronRight,
  chevronUp: ChevronUp,
  megaphone: Megaphone,
  chevronDown: ChevronDown,
  plus: Plus,
  search: Search,
  star: Star,
  send: SendHorizontal,
  more: EllipsisVertical,
  info: Info,
  template: LayoutTemplate,
  phone: Phone,
  video: Video,
  bellOff: BellOff,
  userPlus: UserPlus,
  close: X,
  attach: Paperclip,
  mic: Mic,
  camera: Camera,
  file: FileText,
  stop: Square,
  download: Download,
  archive: Archive,
  moon: Moon,
  sun: Sun,
  repeat: Repeat,
  timer: Timer,
  edit: Pencil,
  link: Link,
  reply: Reply,
  forward: Forward,
  smile: Smile,
  sticker: Sticker,
  images: Images,
  headphones: Headphones,
  calendarPlus: CalendarPlus,
  poll: ChartColumn,
  pin: Pin,
  pinOff: PinOff,
  dock: Dock,
  dockOff: PanelBottomClose,
  appWindow: AppWindow,
  trash: Trash,
  copy: Copy,
  share: Share2,
  saveAs: FolderDown,
  check: Check,
  micOff: MicOff,
  videoOff: VideoOff,
  phoneOff: PhoneOff,
  phoneIncoming: PhoneIncoming,
  phoneOutgoing: PhoneOutgoing,
  phoneMissed: PhoneMissed,
  arrowDownLeft: ArrowDownLeft,
  arrowUpRight: ArrowUpRight,
  minimize: Minimize2,
  maximize: Maximize2,
  pip: PictureInPicture2,
  volume: Volume2,
  mail: Mail,
  book: BookOpen,
  heart: Heart,
  volumeOff: VolumeX,
  external: ExternalLink,
  music: Music,
  click: MousePointerClick,
  flip: SwitchCamera,
  effects: WandSparkles,
  inbox: Inbox,
  play: Play,
  pause: Pause,
  badge: BadgeCheck,
  available: CircleCheck,
  busy: CircleMinus,
  work: BriefcaseBusiness,
  gym: Dumbbell,
  batteryLow: BatteryLow,
  urgent: Siren,
  weather: CloudSun,
  radio: Radio,
  globe: Globe,
  games: Gamepad2,
  minutes: ClipboardList,
  tasks: ListChecks,
  news: Newspaper,
  code: Code,
  brush: Brush,
  quake: Waves,
  target: Target,
  trophy: Trophy,
  help: CircleHelp,
  zap: Zap,
  select: SquareCheck,
  pill: Pill,
  sudoku: Grid3x3,
  bomb: Bomb,
  brain: Brain,
  restart: RotateCcw,
  eraser: Eraser,
  cloud: Cloud,
  cloudRain: CloudRain,
  cloudSnow: CloudSnow,
  cloudStorm: CloudLightning,
  cloudFog: CloudFog,
  cloudDrizzle: CloudDrizzle,
  cloudMoon: CloudMoon,
  humidity: Droplets,
  wind: Wind,
  sunrise: Sunrise,
  sunset: Sunset,
  thermometer: Thermometer,
  locate: LocateFixed,
  map: MapIcon,
  crosshair: Crosshair,
  languages: Languages,
  package: Package,
  truck: Truck,
  scanBarcode: ScanBarcode,
  // Meydan (the social feed) and its views.
  meydan: Landmark,
  atSign: AtSign,
  nabiz: HeartPulse,
  vitrin: GalleryVerticalEnd,
  akis: Rows3,
  kesif: Clapperboard,
  bookmark: Bookmark,
  bookmarkCheck: BookmarkCheck,
  comment: MessageSquare,
  quote: Quote,
  hash: Hash,
  layers: Layers,
  sparkles: Sparkle,
  flame: Flame,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export function Icon({ name, label, size = 20 }: { name: IconName; label?: string; size?: number }) {
  const Glyph = ICONS[name];
  return (
    <Glyph
      className="icon"
      size={size}
      strokeWidth={1.9}
      absoluteStrokeWidth={size < 18}
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
      focusable={false}
    />
  );
}
